import { SortMenuOptions } from 'shared/types/sort-menu-options';
import { GoalGroupBy, GoalSortingMode } from 'shared/types/sorting-mode';

import { GroupByMenuOptions } from './menu-options';

export const groupByOptions: GroupByMenuOptions[] = [
  {
    id: GoalGroupBy.None,
    value: GoalGroupBy.None,
    label: `pages.goals.group-by.label.${GoalGroupBy.None}`,
  },
  {
    id: GoalGroupBy.LifeArea,
    value: GoalGroupBy.LifeArea,
    label: `pages.goals.group-by.label.${GoalGroupBy.LifeArea}`,
  },
];

export const sortOptions: SortMenuOptions<GoalSortingMode>[] = [
  {
    id: GoalSortingMode.Custom,
    value: GoalSortingMode.Custom,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Custom}`,
  },
  {
    id: GoalSortingMode.StartDate,
    value: GoalSortingMode.StartDate,
    label: `general.labels.goals.sort.options.${GoalSortingMode.StartDate}`,
  },
  {
    id: GoalSortingMode.Deadline,
    value: GoalSortingMode.Deadline,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Deadline}`,
  },
  {
    id: GoalSortingMode.Progress,
    value: GoalSortingMode.Progress,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Progress}`,
  },
];
